module.exports = __webpack_public_path__ + "img/category-popular-hover.753cc59d.png";